import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const DashboardLayout = ({ children, className, style }) => {
  return (
    <div className={clsx(className, 'wheel-dashboard-layout w-full h-full relative')} style={style}>{children}</div>
  )
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
}

export default DashboardLayout
